import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconTool } from "@tabler/icons-react";
import { RutasTiendasConfiguracionDef } from "./RutasTiendasConfiguracionDef";

export const RutasTiendasConfiguracionIcon = IconTool;
export const RutasTiendasConfiguracionHelpText = '* Configuración de rutas para tiendas.';

export class RutasTiendasConfiguracion extends Entity<RutasTiendasConfiguracionDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new RutasTiendasConfiguracionDef(), parentKeys);
        this.Form = import('./RutasTiendasConfiguracionForm').then((module) => module.RutasTiendasConfiguracionForm);
        this.Title = "Configuración de Rutas";
        this.HelpText = RutasTiendasConfiguracionHelpText;
        this.Icon = RutasTiendasConfiguracionIcon;
    }
}